import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { CLASS_SETTINGS_SECTION_EMPTY } from '../../../../../../base/components/SettingsSection/constants';
import { CustomPropertiesElements } from '../CustomPropertiesElements/CustomPropertiesElements';
import ReactHtmlParser from 'react-html-parser';
import React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { Button, Icon } from 'kui';
import { getAsidePanelTooltip } from '../../../../../asidePanel/helpers/getAsidePanelTooltip';
import {
    BOARD_CUSTOM_ADD,
    BOARD_CUSTOM_CANCEL,
    BOARD_CUSTOM_EDIT,
    BOARD_SECTION_CUSTOM,
    BOARD_SECTION_CUSTOM_PROPERTIES_TEXT,
    BOARD_SECTION_CUSTOM_SECTION_NEW
} from './constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { ICustomPropertiesProps } from './types';
import {
    CustomPropertiesFormHOC
} from '../../../../../../base/components/CustomProperties/hocs/CustomPropertiesFormHOC/CustomPropertiesFormHOC';
import { CLASS_BOARD_CARD_CUSTOM } from '../../constants';
import './_CustomProperties.scss';
import {
    CLASS_CUSTOM_PROPERTY,
    CLASS_CUSTOM_PROPERTY_ITEM
} from '../../../../../../base/components/CustomProperties/components/constants';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { CLASS_CARD_CUSTOM } from '../../../../../cardDetails/CustomPropertiesSection/components/constants';
import {
    CUSTOM_BUTTON_REMOVE_TOOLTIP
} from '../../../../../cardDetails/CustomPropertiesSection/components/CustomPropertiesElements/constants';
import { CLASS_LIST_ITEM_CONTAINER } from '../../../../../../base/components/ListItem/constants';
import { ListItem } from '../../../../../../base/components/ListItem/ListItem';
import { TCustomPropertyId } from '../../../../../../../../types/types';
import { ORDER_STEP } from '../../../../../../../../const';
import { isEqual } from 'underscore';
import {
    ICustomPropertiesElement
} from '../../../../../../base/components/CustomProperties/components/CustomProperty/types';
import {
    getCustomPropertyValid,
} from '../../../../../../base/components/CustomProperties/helpers/getCustomPropertyValid';
import { ECustomPropertyType } from '../../../../../../../../store/customProperties/types';
import { getElementsClone } from '../../../../../../helpers/getElementsClone';

//@ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`BoardCustomProperties`) : null;

export function CustomProperties ({
    boardId,
    elements,
    isEssentialFeature,
    sectionType,
    onAdd,
    onConfirmDelete,
    onClickCancel,
    onClickEdit,
    onOpen,
    onSave,
    onShowBoardLimitSnackbarIfNeeded,
}: ICustomPropertiesProps) {
    if (analyzeRender) analyzeRender.call(`BoardCustomProperties ${boardId}`);

    const isDefault = sectionType === ESettingsSectionType.DEFAULT;
    const isReadonly = sectionType === ESettingsSectionType.READONLY;
    const isEmpty = !elements.length;

    const classSection = CLASS_BOARD_DETAILS_SECTION;
    const className = CLASS_BOARD_CARD_CUSTOM;
    const classEmpty = CLASS_SETTINGS_SECTION_EMPTY;
    const classEditItem = className + '__edit-item';

    const [isOpened, setIsOpened] = React.useState(null);
    const [isEdit, setEdit] = React.useState(false);
    const [isChanged, setChanged] = React.useState(null);
    const [newProperty, setNewProperty] = React.useState(null);
    const [elementsState, setElements] = React.useState(getElementsClone(elements));
    const [editingPropertyId, setEditingPropertyId] = React.useState(null);

    const onAddOpened = () => {
        setIsOpened(true);
        if (onOpen) onOpen();
        onCancel();
    };

    const onAddClosed = () => {
        setIsOpened(false);
    };

    const onEditHandler = (id?: TCustomPropertyId) => {
        if (id) setEditingPropertyId(id);
        setEdit(true);
        onClickEdit();
    };

    const onCancel = () => {
        setEdit(false);
        setEditingPropertyId(null);
    };

    const onClickCancelHandler = () => {
        onCancel();
        onClickCancel();
    };

    const onDeleteHandler = (id: TCustomPropertyId) => {
        onConfirmDelete(id)
            .then((result) => {
                if (result) {
                    setElements(elementsState.map(item => {
                        return item.id === id
                            ? {
                                ...item,
                                removed: true
                            }
                            : item;
                    }));
                }
            });
    };

    const handleSave = () => {
        if (!getCustomPropertyValid(elementsState, setElements)) return;
        onSave(elementsState);
        setEdit(false);
        setEditingPropertyId(null);
    };

    const onSortHandler = (
        id: TCustomPropertyId,
        index: number,
    ) => {
        let orderNumber: number;
        const elementsNew = elementsState.filter(item => item.id !== id);
        if (index === 0) {
            orderNumber = elementsNew[0].orderNumber + ORDER_STEP;
        } else if (index === elementsState.length - 1) {
            orderNumber = elementsNew[elementsNew.length - 1].orderNumber - ORDER_STEP;
        } else {
            orderNumber = (elementsNew[index - 1].orderNumber + elementsNew[index].orderNumber) / 2;
        }
        setElements(elementsState.map(item => {
            return item.id === id
                ? {
                    ...item,
                    orderNumber,
                }
                : item;
        }).sort((prop1, prop2) => {
            return prop2.orderNumber - prop1.orderNumber; // больший order сверху
        }));
    };

    function onDragEnd(result: DropResult) {
        if (
            !result.destination ||
            result.destination.index === result.source.index
        ) {
            // do nothing
        } else {
            onSortHandler(result.draggableId, result.destination.index);
        }
    }

    const onSortOptionsHandler = (
        propertyId: TCustomPropertyId,
        sourceIndex: number,
        index: number,
    ) => {
        const element = elementsState.find(item => item.id === propertyId);
        const options = [...element.options];
        const option = options.splice(sourceIndex, 1)[0];
        options.splice(index, 0, option);

        setElements(elementsState.map(item => {
            return item.id === propertyId
                ? {
                    ...item,
                    options
                }
                : item;
        }));
    };

    const onChangeProperty = (property: ICustomPropertiesElement) => {
        const newElements = [...elementsState];
        const index = newElements.findIndex(item => item.id === property.id);
        if (index === -1) return;
        newElements.splice(index, 1, property);
        setElements(newElements);
        if (newElements.find(el => el.error)) getCustomPropertyValid(elementsState, setElements);
    };

    React.useEffect(() => {
        if (isEmpty) { // при удалени последнего
            onCancel(); // закрыть Edit
        }
    }, [isEmpty]);

    React.useEffect(() => {
        if (isEdit) {
            let isError = false;
            for (let i = 0; i < elementsState.length; i++) {
                if (
                    elementsState[i].error ||
                    elementsState[i].type === ECustomPropertyType.SELECT &&
                    (!elementsState[i].options || !elementsState[i].options.find(option => option.value))
                ) {
                    isError = true;
                    break
                }
            }
            const currentElements = getElementsClone(elements, true, elementsState).map(({ name, orderNumber, options, removed, type }) => {
                return {
                    name,
                    orderNumber,
                    options,
                    removed,
                    type,
                };
            });
            const newElements = elementsState.map(({ name, orderNumber, options, removed, type }) => {
                return {
                    name,
                    orderNumber,
                    options,
                    removed,
                    type,
                };
            });
            setChanged(!isError && !isEqual(newElements, currentElements));
        }
    }, [isEdit, elementsState]);

    React.useEffect(() => {
        if (!isEdit) {
            setElements(getElementsClone(elements, true, elementsState));
            setChanged(false);
        }
    }, [isEdit, elements]);

    React.useEffect(() => {
        if (!editingPropertyId || !isEdit) return;
        const customProperty = document.querySelector(`.${CLASS_CUSTOM_PROPERTY}__form--${editingPropertyId} .kui-input__item`) as HTMLElement;
        if (!customProperty) return;
        customProperty.focus();
    }, [isEdit, editingPropertyId]);

    return (
        <SettingsSection
            addTitle={BOARD_CUSTOM_ADD}
            isEssentialFeature={isEssentialFeature}
            notBlurClasses={[CLASS_CUSTOM_PROPERTY_ITEM + '-type-select-dropdown']}
            addComponent={
                isOpened ?
                    <>
                        {isEmpty &&
                            <div className={className + '__title'}>
                                {BOARD_SECTION_CUSTOM_SECTION_NEW}
                            </div>
                        }
                        <CustomPropertiesFormHOC
                            boardId={boardId}
                            isNew
                            names={elements.map(element => element.name)}
                            onClose={onAddClosed}
                            setNewProperty={setNewProperty}
                        />
                </> : <div />
            }
            className={`
                ${classSection}
                ${classSection}--card-custom-properties
                ${isEmpty ? classEmpty : ''}
                ${isEmpty && isOpened ? classEmpty + '-opened' : ''}
                ${isEdit ? classSection + '-custom--editing' : ''}
                ${isEdit && !isChanged ? classSection + '-custom--save-disabled' : ''}
                ${newProperty && isOpened ? classSection + '-custom--save-new' : ''}
            `}
            isAddWide={!isEdit}
            isOpened={isOpened}
            title={BOARD_SECTION_CUSTOM}
            titleButton={isReadonly || isEmpty && !isOpened ? null // спрятать крест
                : isEdit ?
                    <>
                        <Button
                            className={className + '__edit'}
                            tooltip={getAsidePanelTooltip({
                                value: BOARD_CUSTOM_CANCEL
                            })}
                            variant={'icon'}
                            onClick={onClickCancelHandler}
                        >
                            <Icon size={24} xlink={'close'} />
                        </Button>
                        <Button
                            variant={'icon'}
                            className={className + '__save'}
                            onClick={handleSave}
                        >
                            <Icon xlink={'done-circle'} size={16} />
                        </Button>
                    </>
                    : isOpened ?
                        <Button
                            variant={'icon'}
                            className={className + '__save-new'}
                            onClick={() => {
                                onAdd(newProperty.name, newProperty.type, newProperty.options);
                                onAddClosed();
                            }}
                        >
                            <Icon xlink={'done-circle'} size={16} />
                        </Button>
                        : <Button
                            className={className + '__edit'}
                            tooltip={getAsidePanelTooltip({
                                value: BOARD_CUSTOM_EDIT
                            })}
                            variant={'icon'}
                            onClick={() => onEditHandler()}
                        >
                            <Icon size={24} xlink={'pen'} />
                        </Button>
            }
            sectionType={sectionType}
            onAddOpened={onAddOpened}
            onAddClosed={() => {
                onAddClosed();
                setNewProperty(null);
            }}
        >
            <>
                {!isOpened && !isEdit &&
                    <div className={className + '__form-text'}>{ReactHtmlParser(BOARD_SECTION_CUSTOM_PROPERTIES_TEXT)}</div>
                }
                {isEdit ?
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={String(boardId)}>
                            {(provided, snapshot) => (
                                <div
                                    className={CLASS_CARD_CUSTOM}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {elementsState.map((element, index) => {
                                        if (element.removed) return null;

                                        return (
                                            <Draggable
                                                draggableId={element.id}
                                                index={index}
                                                isDragDisabled={isReadonly || elements.length === 1}
                                                key={element.id}
                                            >
                                                {(provided, snapshot) => {
                                                    const actions = isReadonly ? null
                                                        : <Button
                                                            variant={'icon'}
                                                            tooltip={ getAsidePanelTooltip({
                                                                direction: 'up-left',
                                                                value: CUSTOM_BUTTON_REMOVE_TOOLTIP,
                                                            })
                                                            }
                                                            onClick={() => onDeleteHandler(element.id)}
                                                        >
                                                            <Icon size={24} xlink={'delete'} />
                                                        </Button>;

                                                    return (
                                                        <div
                                                            className={CLASS_LIST_ITEM_CONTAINER}
                                                            key={element.id}
                                                            {...provided.draggableProps}
                                                            ref={provided.innerRef}
                                                        >
                                                            <ListItem
                                                                actions={actions}
                                                                className={`
                                                                    ${classEditItem}
                                                                    ${classEditItem + '--' + element.type.toLocaleLowerCase()}
                                                                `}
                                                                isDraggable={!isReadonly && elements.length > 1}
                                                                text={<CustomPropertiesFormHOC
                                                                    boardId={boardId}
                                                                    element={element}
                                                                    onChange={(name, type, options) => onChangeProperty({
                                                                        ...element,
                                                                        name,
                                                                        type,
                                                                        options,
                                                                    })}
                                                                    onSortOptions={onSortOptionsHandler}
                                                                    onEnter={handleSave}
                                                                />}
                                                                {...provided.dragHandleProps}
                                                            />
                                                        </div>
                                                    );
                                                }}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    : <CustomPropertiesElements
                        elements={elements}
                        onEdit={isDefault ? onEditHandler : isReadonly ? onShowBoardLimitSnackbarIfNeeded : null}
                    />
                }
            </>
        </SettingsSection>
    );
}
